import { render } from "./ResetPasswordPage.vue?vue&type=template&id=edfe2d68&scoped=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=edfe2d68&lang=css"
import "./ResetPasswordPage.vue?vue&type=style&index=1&id=edfe2d68&lang=css"
import "./ResetPasswordPage.vue?vue&type=style&index=2&id=edfe2d68&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfe2d68"]])

export default __exports__